import { CancellationToken } from "../common/cancellation";

let id = 0;

const MESSAGE_ID_KEY = '$message:id';
const MESSAGE_RESPONSE_KEY = '$message:isResponse';

interface PostMessage {
    type: string;
    [key: string]: any;
}

export function postMessageWithPromise(message: PostMessage, token?: CancellationToken, options?: { timeout?: number }): Promise<any> {

    return new Promise((resolve, reject) => {

        let timeoutId: number | undefined = undefined;
        let didResolve = false;

        // generate a unique ID for this message
        message[MESSAGE_ID_KEY] = id++ + Math.random().toString(36).substring(2, 15) + Date.now();

        function listener(event: MessageEvent) {
            if (event.source !== window) {
                return;
            }
            const INCOMING = event.data;
            // console.log("postMessageWithPromise received message:", INCOMING);
            if (INCOMING.type === message.type && INCOMING[MESSAGE_ID_KEY] === message[MESSAGE_ID_KEY] && INCOMING[MESSAGE_RESPONSE_KEY]) {
                if (didResolve) {
                    return;
                }
                didResolve = true;
                delete INCOMING[MESSAGE_ID_KEY];
                resolve(INCOMING);
                window.removeEventListener('message', listener);
                if (timeoutId) window.clearTimeout(timeoutId);
            }
        }
        function cancel() {
            window.removeEventListener('message', listener);
            if (didResolve) {
                return;
            }
            didResolve = true;
            if (timeoutId !== undefined) {
                window.clearTimeout(timeoutId);
                timeoutId = undefined;
            }
            reject(new Error(`Cancelled waiting for response to message type ${message.type}`));
        }


        timeoutId = window.setTimeout(() => {
            cancel();
        }, options?.timeout ?? 30_000);

        token?.onCancellationRequested(() => {
            cancel();
        });

        window.postMessage(message, '*');
        window.addEventListener('message', listener);
    });

}

